import React, {Component} from 'react';
import {connect} from 'react-redux';
import Config from '../../config';
import '../../styles/channel/ChannelShareCard.css';

class ChannelShareCard extends Component {
    constructor() {
        super();
        this.handleShareLink = this.handleShareLink.bind(this);
    }

    handleShareLink() {
        const {channelId, account} = this.props;
        window.location = Config.MAIN_URL + `/liveroom/channel_get_share_card?channel_id=${channelId}&account_id=${account.id}`;
    }


    render() {
        return (
            <div className="channel-share-card ">
                <a className="default-hover" onClick={this.handleShareLink}>我的邀请卡</a>
            </div>
        )
    }
}

export default connect((state) => ({
    account: state.account,
    channelId: state.channel.channel.id
}))(ChannelShareCard)


// WEBPACK FOOTER //
// ./src/components/channel/ChannelShareCard.js